import { NextRouter } from 'next/router';
import querystring from 'querystring';

export const navigateToResultsPage = async (
    searchParams: Record<string, string | string[]>,
    push: NextRouter['push']
) => {
    const lsrpUrl = await getResultsPageUrl(searchParams);
    // attempt to client side navigate
    if (lsrpUrl) return push(lsrpUrl);
    // fallback to browser /search/
    return push({
        pathname: '/search/',
        query: searchParams
    });
};

export const getResultsPageUrl = async (
    searchParams: Record<string, string | string[] | undefined>
) => {
    try {
        const searchUrl = new URL(
            `/api/search/resolver/?${querystring.stringify(searchParams)}`,
            window.location.href
        );

        const lsrpUrl = await fetch(searchUrl.toString()).then((res) => {
            if (res.ok) return res.text();
            throw new Error('bad response code');
        });
        if (lsrpUrl === '') throw new Error('empty response body');
        return lsrpUrl;
    } catch (e) {
        return;
    }
};

export const formatIdentifier = (path: string | string[]) => {
    if (!Array.isArray(path)) {
        return path;
    }

    const formattedLocation = path.filter((value) => {
        return !isKnownPathSegment(value);
    });

    return formattedLocation.join('/');
};

/*
  Facts:
      We know the geo identifier is the last few segments of the path.
      We know after last "known" path segment from the beginning is the start of the geo identifier
  */
export const isKnownPathSegment = (segment: string): boolean => {
    const knownSegmentRegex = new RegExp(
        '^(' +
            'apartments|auction|barn-conversions|browse|bungalows|business|commercial|commercial|commercial-agents|cottages|' +
            'detached|details|developers|developments|discover|estate-agents|farms-land|find-agents|flats|for-sale|ground-floor|' +
            'home-values|hospitality|house-prices|houses|industrial-sites|land|letting-agents|map|market|new-homes|offices|' +
            'overseas|overseas|overseas-agents|' +
            'property|retail-premises|retirement|semi-detached|serviced-offices|studio|studio-flats|terraced|to-rent|' +
            '\\d-bedroom(s?)' +
            ')$'
    );

    return segment.match(knownSegmentRegex) != null;
};
